import { IParameterGroup, TCreateParameterDTO } from '@/pages/Parameters/parameters.types.ts'

const generateCreateParameterDTO = (initialGroupId: IParameterGroup['id']): TCreateParameterDTO => ({
  name: '',
  sourceId: '',
  groupId: initialGroupId ?? null,
  dataType: 'FLOAT',
  unitId: null,
  unitPrefixId: null,
})

const parametersGenerators = { generateCreateParameterDTO }
export default parametersGenerators
